import apiUrl from '../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import CryptoJS from 'crypto-js';
import { getReasonSubReason } from '../../../services/externalDispute';


export default {
  name: 'DisputeBulkUpload',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      show: false,
      myStr: '',
      isLoading1: false,
      bulkCSVData:[],
      username:'',
      attachment:[],
      FileSelected: null,
      bulkDisputeCSVData:[],
      FailedRecords:'',
      FailedRecords:'',
      bulkDisputeCSVDataFlag:false,
      client:'',
      userFirstLastName : '',
      shipmentTypeList : ["DTO","RTO","DTODispute","ForwardDispute"],
      dtoReasonSub : [],
      rtoReasonSub : [],
      dtoDisputeReasonSub : [],
      forwardDispReasonSub : [],
      requiredColumns: ["ShippingID","Comments","UnboxingVideo","PhotoProof-1","PhotoProof-2", "PhotoProof-3", "PhotoProof-4","OtherProof-1","OtherProof-2"]

    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    var userdetailEncrypt = window.localStorage.getItem('accessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userFirstLastName = userdetail.FirstName
    this.reasonSubReason();

  },
  computed: {

  },

  methods: {
 
    downloadSampleCsv() {
      const headers = this.requiredColumns;
      const csvContent = [headers.join(",")].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "DisputeReopenFile.csv";
      link.click();
  },
    onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;

    },
    uploadFile() {
            var form = new FormData();
            form.append('file', this.attachment);
            form.append('createdBy', this.username);
            // form.append('ClientID', this.client.id);
            form.append('username',this.userFirstLastName)
            var inputpayload = form;
            axios({
              method: 'post',
              url: `${apiUrl.api_url}reopenBulkDispute`,
              data: inputpayload,
              headers: {
                'Authorization': 'Bearer ' + this.myStr
              },
            }).then((result) => {
              if (result.data.ReturnCode !== 100) this.$alertify.error(result.data.ReturnMessage);
              if (result.data.ReturnCode === 100){
              this.bulkDisputeCSVData=result.data.FailedRecords
              this.bulkDisputeCSVDataFlag=true
              this.successData=result.data.Success
              this.FailedRecords=result.data.Failures
            }
            },
              (error) => {
                this.show = false;
                this.displaytable = false;
                console.error(error);
              });

            inputpayload = null;
            this.attachment = null;
            this.FileSelected = null;
    },

    async reasonSubReason() {
      let input = {
        "disputeRaisedType": "Client"
      }
      let taskTypeLength = this.shipmentTypeList.length
      for (let i = 0; i < taskTypeLength; i++) {
        input.taskType = this.shipmentTypeList[i]
        let apiResponse = await getReasonSubReason(input, this.myStr)
        if (apiResponse.data.code == 200){
          let resArray = []
          let reasonSubreasonData = apiResponse.data.data
          let reasonSublength = reasonSubreasonData.length
          for (let i = 0; i < reasonSublength; i++) {
            reasonSubreasonData[i].subReason.forEach((sub) => {
              resArray.push({
                reason: reasonSubreasonData[i].reason,
                subreason: sub.subReason
              });
            })
          }
          if (input.taskType == 'DTO'){
            this.dtoReasonSub = resArray
          }else if (input.taskType == 'RTO'){
            this.rtoReasonSub = resArray
          }else if (input.taskType == 'DTODispute'){
            this.dtoDisputeReasonSub = resArray
          }else if (input.taskType == 'ForwardDispute'){
            this.forwardDispReasonSub = resArray
          }
        }else{
          this.$alertify.error("Dispute Reason Subreason error");
        }

      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/reopenBulkDispute/reopenBulkDispute.component.js